import './App.scss'
import Userform from './features/Userform'
import WaitRipple from './components/WaitRipple'
import { useAtom } from 'jotai';
import { courseAtom, sessionAtom } from './utils/CheckoutService';
import { useI18n } from './utils/lni18n';
import linkifyStr from "linkify-string";
import ErrorDialog from './features/ErrorDialog';
import { useState } from 'react';
import LangButtons from './components/LangButtons';

function App() {

  const { languageService: t } = useI18n();

  const [showPolicy, setShowPolicy] = useState(false);
  const [showCookie, setShowCookie] = useState(false);

  const [courseData] = useAtom(courseAtom);
  const [sessionData] = useAtom(sessionAtom);

  if (courseData === undefined) return <WaitRipple />

  return (
    <>
      <div className="mt-5 align-center container">
        <div className='row'>
          <div className='col-md-8'>

            <h3 className='d-flex'>
              {courseData.Name}
              <LangButtons />
            </h3>

            {(sessionData.sessionStatus === "complete") && (
              <div className='alert alert-warning'>
                <h3>{t.getText("ready")}</h3>
                <div className='preserve-white' dangerouslySetInnerHTML={{ __html: linkifyStr(sessionData.welcomeText!, { truncate: 33 }) }}></div>
              </div>
            )}

            <div dangerouslySetInnerHTML={{ __html: courseData.CourseDescription }}>
            </div>

          </div>

        </div>

      </div>
      <div className='container'>
        <section>
          <div className="row descriptions">
            {courseData.Id != "" && sessionData.sessionStatus !== "complete" && <>
              <div className="col-md-6 mb-4">
                <div className='preserve-white '>
                  {t.getText("checkout.product.description", courseData.MonthsForAccess.toString())}
                </div>
                <div className='mt-3 policy'>
                  <button onClick={() => setShowPolicy(p => !p)} className='mb-3 btn btn-default'>{t.getText("personal.data.policy")}
                    &nbsp;
                    {showPolicy ? <span className="arrow-up"></span> : <span className="arrow-down"></span>}
                  </button>
                  {showPolicy && <div dangerouslySetInnerHTML={{ __html: courseData.DataPolicyText }} ></div>}
                </div>
                <div className='mt-3 policy'>
                  <button onClick={() => setShowCookie(p => !p)} className='mb-3 btn btn-default '>Cookie policy
                    &nbsp;
                    {showCookie ? <span className="arrow-up"></span> : <span className="arrow-down"></span>}
                  </button>
                  {showCookie && <div dangerouslySetInnerHTML={{ __html: courseData.CookieText }} ></div>}
                </div>

              </div>
              <div className="col-md-6">
                <Userform />
              </div>
            </>}

            <div className="clearfix"></div>
          </div>
        </section>
      </div>
      <ErrorDialog />

    </>
  )
}

export default App
